// extracted by mini-css-extract-plugin
export default {"updateAppLinks":"UpdatePage_updateAppLinks__ruxNF"};